/**
 * Parse formatted price as not everywhere we have the unformatted price available
 *
 * @param currencyLiteral formatted price with currency and with double decimal or no decimal
 * @returns {number} number as float if 2 decimals and as integer if no decimals
 */
export const parseFormattedPrice = (currencyLiteral: string): number => {
  const sanitizedNumber = currencyLiteral.replaceAll(/[^\d.,]/g, '');

  const normalizedSeparators = sanitizedNumber.replaceAll(',', '.');

  const numberParts = normalizedSeparators.split('.');

  const [possibleDecimal, ...restNumber] = [...numberParts].reverse();

  if (possibleDecimal.length === 2 && restNumber.length > 0) {
    return parseFloat([restNumber.reverse().join(''), possibleDecimal].join('.'));
  }

  return parseFloat(numberParts.join(''));
};
